import * as Yup from 'yup';

export const enterprisePlanSchema = Yup.object().shape({
  application: Yup.string().required('Application type is required'),
  amountPaid: Yup.number().required('Amount Paid type is required'),
  provider: Yup.string().required('Provider is required'),
  subdomain: Yup.string(),
  paymentId: Yup.string().required('Payment ID type is required'),
  transactionDate: Yup.date().required('Transaction date is required'),
  expiresOn: Yup.date().required('Expiration date is required'),
  frequency: Yup.string().required('Frequency is required'),
  activateOn: Yup.date().required('Subscription commencement date is required'),
  currency: Yup.string().required('Currency is required'),
  logo: Yup.string(),
  companyName: Yup.string().required('Company name is required'),
  adminFirstname: Yup.string().required('Admin first name is required'),
  adminLastname: Yup.string().required('Admin last name is required'),
  adminEmail: Yup.string().email('Invalid email').required('Admin email address is required'),
  personalEmail: Yup.string().email('Invalid email').required('Personal email address is required'),
  companyType: Yup.string().required('Company type is required'),
  country: Yup.string().required('Country is required'),
  maxNumberofUser: Yup.number(),
  storageInGigaByte: Yup.number(),
  communicationHistoryInMonth: Yup.number(),
  projectLimit: Yup.number(),
  dataRetentionPeriodInMonth: Yup.number(),
  isNumberOfUserUnlimited: Yup.boolean(),
  isStorageUnlimited: Yup.boolean(),
  keepCommunicationForever: Yup.boolean(),
  keepProjectCreationForever: Yup.boolean(),
  timeSheetManagement: Yup.boolean(),
  keepDataRetentionForever: Yup.boolean(),
  aiAssistance: Yup.boolean(),
  unlimitedActivityLog: Yup.boolean(),
  planId: Yup.boolean(),
});

export const noPaymentEnterprisePlanSchema = Yup.object().shape({
  application: Yup.string().required('Application type is required'),
  provider: Yup.string().required('Provider is required'),
  subdomain: Yup.string(),
  expiresOn: Yup.date().required('Expiration date is required'),
  frequency: Yup.string().required('Frequency is required'),
  activateOn: Yup.date().required('Subscription commencement date is required'),
  logo: Yup.string(),
  companyName: Yup.string().required('Company name is required'),
  adminFirstname: Yup.string().required('Admin first name is required'),
  adminLastname: Yup.string().required('Admin last name is required'),
  adminEmail: Yup.string().email('Invalid email').required('Admin email address is required'),
  personalEmail: Yup.string().email('Invalid email').required('Personal email address is required'),
  companyType: Yup.string().required('Company type is required'),
  country: Yup.string().required('Country is required'),
  maxNumberofUser: Yup.number(),
  storageInGigaByte: Yup.number(),
  communicationHistoryInMonth: Yup.number(),
  projectLimit: Yup.number(),
  dataRetentionPeriodInMonth: Yup.number(),
  isNumberOfUserUnlimited: Yup.boolean(),
  isStorageUnlimited: Yup.boolean(),
  keepCommunicationForever: Yup.boolean(),
  keepProjectCreationForever: Yup.boolean(),
  timeSheetManagement: Yup.boolean(),
  keepDataRetentionForever: Yup.boolean(),
  aiAssistance: Yup.boolean(),
  unlimitedActivityLog: Yup.boolean(),
  planId: Yup.boolean(),
});

// .required('Application type is required')
// .required('Amount paid is required')
// .required('Subdomain is required')
//.required('Payment ID is required')
// .required('Transaction date is required')
// .required('Frequency is required')
// .required('Subscription commencement date is required')
// .required('Currency is required')
// .required('Logo is required')
// .required('Max number of users is required')
// .required('Company name is required')
// .required('Admin first name is required')
// .required('Admin last name is required')
// .required('Admin email address is required')
// .required('Admin phone number is required')
// .required('Domain name is required')
// .required('Company type is required')
// .required('Country is required')

export const generateschema = Yup.object().shape({
  companyName: Yup.string().required("Company name is required"),
  companyEmail: Yup.string().required("Company email is required"),
  amount: Yup.string().required("Amount is required"),
  frequency: Yup.string().required("Frequency is required"),
  currency: Yup.string().required("Currency is required"),
  personalEmail: Yup.string().required("Personal email is required"),
  isExistingUser: Yup.string(),
});